// File: components/DutyList/RoleSelector.js
import React from "react";

const RoleSelector = ({ selectedRoles, setSelectedRoles }) => {
  const toggleRole = (roleKey) => {
    setSelectedRoles((prev) => ({ ...prev, [roleKey]: !prev[roleKey] }));
  };

  return (
    <div className="row g-2 mb-4">
      <div className="col-md-3">
        <label className="form-label">Export Roles</label>

        {[
          { key: "Doctor", label: "Doctor" },
          { key: "Nurse", label: "Nurse" },
          { key: "FireFighting", label: "Fire Fighting Team" },
          { key: "RapidResponseGround", label: "Rapid Response Team (Ground Floor)" },
          { key: "RapidResponseFirst", label: "Rapid Response Team (First Floor)" },
        ].map((role) => (
          <div className="form-check" key={role.key}>
            <input
              className="form-check-input"
              type="checkbox"
              id={`${role.key}Check`}
              checked={selectedRoles[role.key]}
              onChange={() => toggleRole(role.key)}
            />
            <label className="form-check-label" htmlFor={`${role.key}Check`}>
              {role.label}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RoleSelector;
